import sortingTableComponent from './sorting-table.component';

const sortingTableModule = angular.module('sortingTable', [
])
  .component('sortingTable', sortingTableComponent)
  .name;

export default sortingTableModule;
